import { createI18n } from "vue-i18n"
import translations from "./i18n-locale/translations";
import dateTimeFormats from "./i18n-locale/date-time-formats"
import numberFormats from "./i18n-locale/number-formats"

const i18n = createI18n({
    // todo fix where we have $t $i18n etc when legacy is set to false
    legacy: true,
    locale: 'en',
    fallbackLocale: 'en',
    messages: translations,
    dateTimeFormats,
    numberFormats
});

export const setLocale = (locale) => {
    console.log('setLocale', locale);
    if (translations[locale]) {
        i18n.global.locale = locale;
    } else {
        console.error(`Locale ${locale} not found.`);
    }
};

export default i18n;